/**
 * Integration Marketplace Demo — demo-mode flag (delegates to the shared global
 * toggle).
 *
 * THROWAWAY DEMO CODE. Everything under `frontend/src/demo/im/` exists only to
 * drive the UI-only "Integration Link" ingestion demo and is meant to be
 * deleted wholesale afterwards (see ./README.md → Deletion checklist). It must
 * never be imported by production code except via the thin, clearly-commented
 * guards listed in the README.
 *
 * IM no longer owns its own flag — it shares the single global demo switch in
 * `@/demo/core/demo-mode`. These wrappers keep IM's familiar `isImDemoMode()` /
 * `setImDemoMode()` API for its route guards and components.
 */

import {
  isDemoMode,
  setDemoMode,
  refreshDemoMode,
} from '@/demo/core/demo-mode';

/** True when demo mode is on. */
export function isImDemoMode(): boolean {
  return isDemoMode();
}

/** Re-read the flag from sessionStorage (e.g. after navigation). */
export function refreshImDemoMode(): boolean {
  return refreshDemoMode();
}

/** Toggle demo mode (used by the reset/exit control). */
export function setImDemoMode(enabled: boolean): void {
  setDemoMode(enabled);
}
